import BaseConfig from '@/config/base.js'

// 根据 isRelease 取包对应页面域名：正式取 host 数组第一个，测试取最后一个
export function getPageHost(packageName) {
  const hosts = BaseConfig.apps[packageName]?.hosts
  if (!hosts || !hosts.length) {
    return ''
  }
  return BaseConfig.isRelease ? hosts[0] : hosts[hosts.length - 1]
}

// src\views\P3_Page使用, 将相对路径或带域名的路径转为当前环境可用的 iframe src
export function buildPageSrc(packageName, path) {
  if (!path) return ''

  // 本地开发环境直接走 public 目录下的静态文件，避免 iframe 去拉远程测试服务器
  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    return path
  }

  const host = getPageHost(packageName)
  if (!host) return path

  if (path.startsWith('http://') || path.startsWith('https://')) {
    try {
      const url = new URL(path)
      url.protocol = 'https:'
      url.host = host
      return url.toString()
    } catch (err) {
      return path
    }
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `https://${host}${normalizedPath}`
}
